define((require) => {
    "use strict";

    var Store = require("channels/Store"), // for key prefix only
        util  = require("channels/Util");

    // Parses the cookies into a map...
    var parse = function(cookie) {
        var data = {index: util.options(cookie), keys: [], external: {}}, // external: for stuff like opt out of cookie usage... :)
            key;

        for (key in data.index) {
            // Filter out all values we know are not channel related...
            if (util.idx(key, Store.KEY_PREFIX) === 0) {
                data.keys.push(key);
            } else {
                data.external[key] = data.index[key];
                delete data.index[key];
            }
        }

        return data;
    };

    /**
     * @class
     * The <i>Cookie</i> type describes the channel interaction with (secure) cookie storage when
     * wrapped by the <tt>Store</tt> type. <p>
     *
     * Cookie storage is not well suited for storing large json date; prefer <tt>Storage</tt> for
     * that. It usage here is mainly to allow our test suites to be configured with different
     * snippet configurations as the test suite only supports cookies, not session/local storage. <p>
     *
     * The <tt>get(..)</tt> function is augmented with an optional third boolean argument that on <tt>true</tt>
     * will look up an external cookie name, for example to read an opt-out cookie name not having our
     * <tt>Store.KEY_PREFIX</tt>; the second <tt>timeout</tt> argument on get is always ignored by a
     * cookie storage as this is built-in to the cookie itself.
     *
     * @param {HTMLDocument} doc      The document defining the backing HTML5 cookie, e.g.
     *                                <tt>window.document.cookie</tt> under the document <tt>window.document</tt>.
     * @param {Boolean}      secure   True if secure (https), false otherwise (http, default).
     *
     * @return {Function} A constructor <tt>ctor(doc:Document, secure:Boolean)</tt> to create the Cookie storage
     *                    for the Cookie Store;  never falsey. The returned store can also index external cookie
     *                    keys using <tt>this.get(key, ignoredTimeout, true)</tt>, e.g. to read cookies like
     *                    opt-out cookies.
     */
    return function(doc, secure) {
        var scope = this,
            storage = function() {
                if (!_storage) {
                    _storage = parse(doc.cookie);
                }
                return _storage;
            },
            _storage = null;

        this.size = function() {
            return storage().keys.length;
        };

        this.key = function(index) {
            return storage().keys[index];
        };

        // timeout (second argument) never used on get, set on put as per standard cookie behaviour,
        // but supplied by default from Store...
        this.get = function(key) {
            return storage()[arguments[2] ? "external" : "index"][key];
        };

        this.put = function(key, value, timeout) {
            var expires = "",
                postfix = "; path=/";

            if (timeout) {
                var date = util.now();
                date.setTime(date.getTime() + timeout);
                expires = "; expires=" + date.toGMTString();
            }
            if (secure) {
                postfix += "; secure";
            }
            doc.cookie = key + "=" + value + expires + postfix;
            _storage = null; // force re-parse when needed
        };

        this.remove = function(key) {
            scope.put(key, "", -1);
            _storage = null; // force re-parse when needed
        };
    };
});



// WEBPACK FOOTER //
// ./src/channels/channels/Cookie.js